import React from 'react';
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import {Button, Checkbox, Modal} from "semantic-ui-react";
import PricingTablesListRowV2 from "./PricingTablesListRowV2";
import {connect} from "react-redux";
import AddEditPricingFormV2 from "./AddEditPricingFormV2";
import {
    toggleUploadPricingModal,
    toggleAddPricingTableModalV2,
    validatePricingTableV2,
    togglePricingTableSortV2,
    pricingTablesSearchV2,
    uploadPricingTableData
} from "../actions/PricingTablesActions";
import {PricingTableSortFields} from "../constants/PricingTablesActionConstants";
import {TableSearch} from "../../../common/components/TableSearch";
import * as Validation from "../../../common/utils/Validation";
import UploadPricingDataForm from "./UploadPricingDataForm";

export class PricingTablesTableV2 extends React.Component {

    static propTypes = {
        PricingTablesData: PropTypes.array,
    }

    state = {
        selectedFile: null
    }

    handleUploadPricingDataClick = () => {
        this.props.togglePricingUploadModal();
        this.setState({ selectedFile: null });
        Validation.clearMessages();
    }

    handleDismiss = () => {
        Validation.clearMessages();
    }

    handleAddPricingTableClick = () => {
        this.props.togglePricingTableModal();
    }

    handleAddPricingTableFormSubmit = () => {
        this.props.validatePricingTableForm(this.props.pricingTableObjectV2);
    }

    handlePricingTableSort = (sortKey) => {
        this.props.changePricingTableSort(sortKey);
    }

    handlePTTableSearch = (e) => {
        this.props.typeAheadSearchPT(e.target.value)
    }

    handleFileUpload = () => {
        if (this.state.selectedFile) {
            this.props.uploadPricingData(this.state.selectedFile);
            console.log("Uploading file:", this.state.selectedFile.name);
            // Reset file selection and close modal
            Validation.clearMessages();
            this.setState({ selectedFile: null });
        }
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox disabled/>
            </Table.Header>,
            <Table.Header key="pricing-table-name" sortKey={PricingTableSortFields.NAME}>Pricing Table</Table.Header>,
            <Table.Header key="pricing-table-base-price" sortKey={PricingTableSortFields.BASE_PRICE}>Base Price</Table.Header>,
            <Table.Header key="pricing-table-countries" sortKey={PricingTableSortFields.COUNTRY_COUNT}>Country Count</Table.Header>,
            <Table.Header key="pricing-table-tenants" sortKey={PricingTableSortFields.TENANT_COUNT}>Tenant Count</Table.Header>,
            <Table.Header key="pricing-table-vol-agg">Volume Aggregation</Table.Header>,
            <Table.Header key="pricing-table-updated" sortKey={PricingTableSortFields.LAST_UPDATED}>Last Updated</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.PricingTablesData.map((tableData, idx) => (
            <PricingTablesListRowV2
                key={idx}
                pricingID={tableData.pricing_id}
                pricingName={tableData.name}
                countryCount={tableData.country_count}
                tenantCount={tableData.tenant_count}
                basePrice={tableData.base_price}
                volumeAggregationType={tableData.volume_aggregation_type}
                lastUpdated={tableData.last_updated}
            />
        ))
    }

    render() {
        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Button
                        icon="file excel outline" size="big"
                        disabled={true}
                    />
                    {this.props.canEdit
                        ? (
                            <>
                                <Button
                                    style={{float: "right"}} color="blue"
                                    icon="upload"
                                    content="Upload Pricing Data"
                                    onClick={this.handleUploadPricingDataClick}
                                />
                                <Button
                                    style={{float: "right"}} color="blue"
                                    icon="add"
                                    content="Manually create a new Pricing Table"
                                    onClick={this.handleAddPricingTableClick}
                                />
                            </>
                        )
                        : null}
                </div>

                <div className="billing-list-container">
                    <TableSearch
                        handleSearch={this.handlePTTableSearch}
                    />
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table sortable"
                            currSortKey={this.props.pricingTableSortKey}
                            sortDirection={this.props.pricingTableSortDirection}
                            headers={this.tableHeaders}
                            onSort={this.handlePricingTableSort}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>

                <Modal
                    centered
                    dimmer="blurring"
                    open={this.props.addPTModalOpen}
                >
                    <Modal.Header>
                        {"Add a new Pricing Table"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditPricingFormV2 />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleAddPricingTableClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddPricingTableFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered
                    dimmer="blurring"
                    open={this.props.uploadPTModalOpen}
                    size="small"
                >
                    <Modal.Header>
                        <i className="cloud upload icon" style={{ marginRight: "10px" }} />
                        Upload Pricing Table Data
                    </Modal.Header>
                    <Modal.Content style={{ padding: "40px" }}>
                        <UploadPricingDataForm
                            messagesEndRef={this.messagesEndRef}
                            formMessage={this.props.formMessage}
                            formWarningNotification={this.props.formWarningNotification}
                            formErrorNotification={this.props.formErrorNotification}
                            formSuccessNotification={this.props.formSuccessNotification}
                            formMessageHeader={this.props.formMessageHeader}
                            selectedFile={this.state.selectedFile}
                            onFileSelect={(file) => this.setState({ selectedFile: file })}
                            onDismiss={this.handleDismiss}
                        />
                    </Modal.Content>
                    <Modal.Actions style={{
                        backgroundColor: "#f8f9fa",
                        padding: "20px",
                        borderTop: "1px solid #e9ecef"
                    }}>
                        <Button
                            inverted
                            color="red"
                            onClick={this.handleUploadPricingDataClick}
                        >
                            Cancel
                        </Button>
                        <Button
                            inverted
                            color="green"
                            disabled={!this.state.selectedFile}
                            onClick={this.handleFileUpload}
                            style={{ marginLeft: "10px" }}
                        >
                            <i className="upload icon" />
                            Upload & Process
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isPricingAdmin,
    pricingTableSortKey: state.billing.pricing.pricingTableSortKey,
    pricingTableSortDirection: state.billing.pricing.pricingTableSortDirection,
    pricingTableObjectV2: state.billing.addEditPricingTable.pricingTableObjectV2,
    uploadPTModalOpen: state.billing.addEditPricingTable.uploadPTModalOpen,
    addPTModalOpen: state.billing.addEditPricingTable.addPTModalOpen,

    // Add message state
    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formSuccessNotification: state.marvel.message.formSuccessNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    togglePricingUploadModal: () => {dispatch(toggleUploadPricingModal())},
    togglePricingTableModal: () => {dispatch(toggleAddPricingTableModalV2())},
    validatePricingTableForm: (pricingTableObjectV2) => {dispatch(validatePricingTableV2(pricingTableObjectV2))},
    changePricingTableSort: (sortKey) => {dispatch(togglePricingTableSortV2(sortKey))},
    typeAheadSearchPT: (value) => {dispatch(pricingTablesSearchV2(value))},
    uploadPricingData: (file) => {dispatch(uploadPricingTableData(file))}
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PricingTablesTableV2)

